module.exports = __webpack_public_path__ + "img/145.5.04daf536.png";